import CreditStatus from '../../../constants/credit.status';

export const UseCreditButtonEnabled = [CreditStatus.ACTIVE, CreditStatus.USED];

export const CreditCardAvailable = [
  CreditStatus.ACTIVE,
  CreditStatus.USED,
  CreditStatus.BLOCKED,
];

export const ShowCreditsMessages = [
  CreditStatus.NOT_APPLIED,
  CreditStatus.APPROVED,
  CreditStatus.PENDING_APPROVAL,
  CreditStatus.ACTIVE,
];

export const ShowAutomaticCreditsMessages = [
  CreditStatus.APPROVED,
  CreditStatus.ACTIVE,
];

export const CreditDisabled = [CreditStatus.BLOCKED, CreditStatus.REJECTED];
